import React from "react";
import { Box, Typography } from "@mui/material";

import MobileAppShell from "../../layout/MobileAppShell";
import Section from "./Section";
import ProfilePicture from "./ProfilePicture";
import PersonalDetails from "./PersonalDetails";
import ChangePassword from "./ChangePassword";

/**
 * Mobile Profile page — the mobile equivalent of the desktop `/:client/profile`
 * route (components/Profile/index.jsx).
 *
 * Ports two of desktop's three blocks:
 *   1. Student profile — picture + name/email.
 *   2. Change password.
 *
 * Desktop's "My Resume" block is deliberately NOT ported: resumes only feed the
 * interview-wizard / personalised-assessment flows, none of which exist on
 * mobile (Teach & Train is the only mobile feature), so a resume uploaded here
 * would have nowhere to be used.
 */
export default function MobileProfile() {
  return (
    <MobileAppShell title="Profile">
      <Box
        sx={{ px: 4, py: 4, display: "flex", flexDirection: "column", gap: 5 }}
      >
        {/* Page header band — same treatment as the Performance screen. */}
        <Typography
          variant="h6-bold"
          color="primary.clr-300"
          sx={{
            pb: 2,
            borderBottom: "2px solid",
            borderColor: "primary.clr-300",
          }}
        >
          Profile
        </Typography>

        <Section
          heading="Setup your student profile"
          subheading="These details will reflect in dashboard & other places"
        >
          <ProfilePicture />
          <PersonalDetails />
        </Section>

        <Section
          heading="Change your password"
          subheading="Use a password you don't use anywhere else"
        >
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <img
              src="https://assets.languify.in/images/updatePass.png"
              alt="update password"
              width={120}
              height={120}
            />
          </Box>
          <ChangePassword />
        </Section>
      </Box>
    </MobileAppShell>
  );
}
